/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Chronoctl Dashboard";
const frontMatter = {};
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return <><_components.p>{"Chronosphere Observability Platform imports, exports, and updates dashboards as JSON\nrepresentations, which you can submit to Observability Platform as an inline string value in\nthe "}<_components.a href="/tooling/chronoctl">{"Chronoctl"}</_components.a>{" YAML representation of a dashboard resource."}</_components.p>{"\n"}<_components.p>{"For details about creating and updating dashboard JSON in Chronoctl YAML, see\n"}<_components.a href="/observe/dashboards#create-a-dashboard">{"Create a dashboard"}</_components.a>{". For details about the panel\nJSON representation format, see\n"}<_components.a href="/observe/dashboards/panels/json-representation">{"JSON representation"}</_components.a>{"."}</_components.p></>;
}

export default MDXLayout